import {
    categoryOption,
    typeOption,
} from "@/app/shared/ecommerce/product/create-edit/form-utils";
import FormGroup from "@/app/shared/form-group";
import cn from "@/utils/class-names";
import { Controller, useFormContext } from "react-hook-form";
import { Input, Select } from "rizzui";
// const Select = dynamic(() => import('rizzui').then((mod) => mod.Select), {
//   ssr: false,
//   loading: () => <SelectLoader />,
// });
import QuillEditor from "@/ui/quill-editor";

export default function ProductSummary({ className }: { className?: string }) {
    const {
        register,
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <FormGroup
            title="Summary"
            description="Edit your product description and necessary information from here"
            className={cn(className)}
        >
            <Input
                label="Title"
                placeholder="Product title"
                {...register("title")}
                error={errors.title?.message as string}
            />
            <Input
                label="SKU"
                placeholder="Product sku"
                {...register("sku")}
                error={errors.sku?.message as string}
            />

            <Controller
                name="type"
                control={control}
                render={({ field: { onChange, value } }) => (
                    <Select
                        dropdownClassName="h-auto"
                        options={typeOption}
                        value={value}
                        onChange={onChange}
                        label="Product Type"
                        error={errors?.type?.message as string}
                        getOptionValue={(option) => option.value}
                    />
                )}
            />

            <Controller
                name="categories"
                control={control}
                render={({ field: { onChange, value } }) => (
                    <Select
                        options={categoryOption}
                        value={value}
                        onChange={onChange}
                        label="Categories"
                        error={errors?.categories?.message as string}
                        getOptionValue={(option) => option.value}
                        dropdownClassName="h-auto"
                    />
                )}
            />

            <Controller
                control={control}
                name="description"
                render={({ field: { onChange, value } }) => (
                    <QuillEditor
                        value={value}
                        onChange={onChange}
                        label="Description"
                        className="col-span-full [&_.ql-editor]:min-h-[100px]"
                        labelClassName="font-medium text-gray-700 dark:text-gray-600 mb-1.5"
                    />
                )}
            />
        </FormGroup>
    );
}